
declare module "react" {
    interface ImgHTMLAttributes<T> {
        code?: string;
    }
}


const Enamad = () => {
    return (
        <a
            referrerPolicy="origin"
            target="_blank"
            href="https://trustseal.enamad.ir/?id=728306&Code=uI49itdaMGLOvOlg0d5z6ebC6cYcACuC"
        >
            <img
                referrerPolicy="origin"
                src="https://trustseal.enamad.ir/logo.aspx?id=728306&Code=uI49itdaMGLOvOlg0d5z6ebC6cYcACuC"
                alt=""
                code="uI49itdaMGLOvOlg0d5z6ebC6cYcACuC"
                style={{ cursor: "pointer" }}
            />
        </a>
    );
};


export default Enamad;
